import { render } from "./infoIcons.vue?vue&type=template&id=4de333de"
import script from "./infoIcons.vue?vue&type=script&lang=js"
export * from "./infoIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__